import Layout from "components/layout";
import React from "react";
import Localization from "components/reusableComponents/staticPages/localizationIndexPages/index";
import SEO from "components/seo";

export default function index() {
  const title = "Localization Services | Tomedes";
  const description =
    "Tomedes provides localization services to the world's leading tech providers & Fortune 500 companies. More than 815 supported languages. Get a free quote now.";
  const keywords =
    "localization, localization service, localization services, video game localization, software localization, marketing localization, IT localization, Website translation, Document translation, Video translation";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug="/localization-services.php"
      />
      <Localization />
    </Layout>
  );
}
